window.dataLayer = window.dataLayer || [];
window.customer_consent =false;
function gtagConcentMode(){dataLayer.push(arguments);}
// Function to set a cookie
function setCookie(cname, cvalue, path, exdays, exhours) {
  let cookieStr = `${cname}=${cvalue || ""}`; 
  path = path || '/';
  
  if (exdays) {
    exdays = exdays ?? 1;
    exhours = exhours ?? 24;
    const d = new Date();
    d.setTime(d.getTime() + (exdays * exhours * 60 * 60 * 1000));
    cookieStr += `; expires=${d.toUTCString()}`;
  }

  cookieStr += `; path=${path}`;
  document.cookie = cookieStr;  
}
  // Function to get a cookie
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  
  // Fetches geolocation once per session and returns both region flags
  const EU_COUNTRIES = ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','IS','LI','NO','GB'];
  async function getVisitorRegion() {
    let locationData = null;
    const cachedLocation = sessionStorage.getItem('geo_location');
    if (cachedLocation) {
      try {
        locationData = JSON.parse(cachedLocation);
      } catch (e) {
        console.error('Error parsing cached location data:', e);
      }
    }
    if (!locationData) {
      try {
        const response = await fetch('https://dq0jpe8685dh3.cloudfront.net/geo-consent');
        if (!response.ok) {
          throw new Error('Geolocation API request failed');
        }
        locationData = await response.json();
        sessionStorage.setItem('geo_location', JSON.stringify(locationData));
      } catch (error) {
        console.error('Error fetching geolocation:', error);
        return { isCaliforniaVisitor: false, isEUVisitor: false };
      }
    }
    return {
      isCaliforniaVisitor: locationData.country === 'US' && locationData.region === 'CA',
      isEUVisitor: EU_COUNTRIES.includes(locationData.country)
    };
  }

  // SYNCHRONOUS consent default — must run before any GTM/GA tag fires.
  // Reads from existing cookies if available; otherwise denies everything by default
  // (GDPR-safe). The async region check below may upgrade this via 'consent update'.
  (function consentDefaultSync() {
    const hasCookies = getCookie('marketingAllowed') !== null;
    const marketingAllowed = hasCookies && getCookie('marketingAllowed') === 'true';
    const analyticsAllowed = hasCookies && getCookie('analyticsProcessingAllowed') === 'true';
    gtagConcentMode('consent', 'default', {
      'ad_storage': marketingAllowed ? 'granted' : 'denied',
      'ad_user_data': marketingAllowed ? 'granted' : 'denied',
      'ad_personalization': marketingAllowed ? 'granted' : 'denied',
      'analytics_storage': analyticsAllowed ? 'granted' : 'denied',
      'wait_for_update': 500
    });
    dataLayer.push({ event: 'concent_initializing' });
  })();

  async function consentDefault() {
    // Check if user is from California or EU for initial consent default
    const { isCaliforniaVisitor, isEUVisitor } = await getVisitorRegion();

    let marketingAllowed = getCookie('marketingAllowed') == 'true' ? true : 'x';
    let analyticsProcessingAllowed = getCookie('analyticsProcessingAllowed') == 'true' ? true : 'x';
    let preferencesProcessingAllowed = getCookie('preferencesProcessingAllowed') == 'true' ? true : 'x';
    if(getCookie('marketingAllowed') === null){
      console.log('dont found cookies set all on default');
      // For California and EU visitors, default to denied (false) instead of customer_consent
      const defaultConsent = ((isCaliforniaVisitor || isEUVisitor) ? false : window.customer_consent) ? 'true' : 'false';

      marketingAllowed = defaultConsent;
      analyticsProcessingAllowed = defaultConsent;
      preferencesProcessingAllowed = defaultConsent;

      setCookie('marketingAllowed', marketingAllowed, '/', 180);
      setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, '/', 180);
      setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, '/', 180);
    }
    // Push as 'update' (not 'default') because the synchronous default already fired.
    gtagConcentMode('consent', 'update', {
      'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
      'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
      'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
      'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
    });
    dataLayer.push({event:'concent_region_resolved'});
  }
  consentDefault();

  // Function to toggle aria-hidden on external elements
  function handleBodyAriaHidden(hidden, exceptionElement) {
    if (hidden && !exceptionElement) return;

    if (!hidden) {
       // Cleanup all elements we hid
       const hiddenElements = document.querySelectorAll('[data-consent-hidden="true"]');
       hiddenElements.forEach(el => {
         el.removeAttribute('aria-hidden');
         el.removeAttribute('data-consent-hidden');
       });
       return;
    }

    // Helper to toggle attribute
    const setHidden = (el) => {
      if (el === exceptionElement) return;
      // Also ignore the overlay associated with the exception if possible, or generic overlay
      if (el.id === 'custom-consent-overlay') return;
      if (['SCRIPT', 'STYLE', 'LINK', 'BASE', 'META', 'TITLE', 'NOSCRIPT'].includes(el.tagName)) return;

      if (!el.hasAttribute('aria-hidden')) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('data-consent-hidden', 'true');
      }
    };

    // Traverse up from exceptionElement
    let current = exceptionElement;
    while(current && current.parentElement) {
      const parent = current.parentElement;
      Array.from(parent.children).forEach(sibling => {
        if (sibling !== current) {
          setHidden(sibling);
        }
      });
      
      if (parent === document.body) break;
      current = parent;
    }
  }

  // Variable to store the focus trap cleanup function
  let consentModalFocusTrapHandler = null;

  // Setup focus trap for cookie consent popup
  const setupConsentFocusTrap = function() {
    const dialog = document.getElementById('custom-consent-popup');
    if (!dialog) return;

    const getFocusableElements = () => {
      // Select all standard focusable elements
      return Array.from(dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )).filter(el => {
        // Filter out disabled, hidden, or non-visible elements
        return !el.hasAttribute('disabled') && 
               !el.getAttribute('aria-hidden') && 
               el.offsetParent !== null;
      });
    };

    const handleKeyDown = function(e) {
      if (e.key === 'Tab') {
        const focusableElements = getFocusableElements();
        if (focusableElements.length === 0) return;

        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) { /* shift + tab */
          if (document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
          }
        } else { /* tab */
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    };

    dialog.addEventListener('keydown', handleKeyDown);
    
    return function cleanup() {
      dialog.removeEventListener('keydown', handleKeyDown);
    };
  };


  document.addEventListener('readystatechange', async function (event) {
    if (event.target.readyState === "complete") {
      await initCookies();
    }
  });
  async function initCookies () {
    const consentFooter = document.getElementById('custom-consent-footer');
    const overlay = document.getElementById('custom-consent-overlay');
    const consentPopup = document.getElementById('custom-consent-popup');
    const openConsentButton = document.getElementById('openConsentPopup');
    const saveConsentButton = document.getElementById('saveConsent');
    const saveAcceptConsentAll = document.querySelectorAll('.cookies-concent-save-all');
    const declineConsentAll = document.querySelectorAll('.cookies-concent-decline-all');
    const btnAcceptAll = document.querySelector('#accept-all-cookies');
    const privacyLink = document.querySelector('#custom-consent-footer p a');
    const closePopupButton = document.getElementById('closeConsentPopup');
    const closeFooterButton = document.getElementById('closeFooterPopup');
    const cookieSettingsAnchors = document.querySelectorAll('a[href="#cookie-settings"]');
    const showMoreButton = document.querySelector('#custom-consent-footer button.show-more');
    const announcementBarLink = document.querySelector('.announcement-bar-section');
    const toggleMkarketing = document.querySelectorAll('.cookie-checkbox-label');
    
    // Check if user is from California or EU and hasn't set preferences yet
    const { isCaliforniaVisitor, isEUVisitor } = await getVisitorRegion();
    const hasSetPreferences = localStorage.getItem('privacy-concent') === 'true';

    // Sync checkbox state from saved cookies (covers EU/California where Shopify
    // privacy sync block below is skipped, so popup reflects the real choice on refresh)
    const marketingCookie = getCookie('marketingAllowed');
    const analyticsCookie = getCookie('analyticsProcessingAllowed');
    const preferencesCookie = getCookie('preferencesProcessingAllowed');
    const marketingCheckbox = document.getElementById('marketingAllowed');
    const analyticsCheckbox = document.getElementById('analyticsAllowed');
    const preferencesCheckbox = document.getElementById('preferencesAllowed');
    if (marketingCheckbox && marketingCookie !== null) {
      marketingCheckbox.checked = marketingCookie === 'true';
    }
    if (analyticsCheckbox && analyticsCookie !== null) {
      analyticsCheckbox.checked = analyticsCookie === 'true';
    }
    if (preferencesCheckbox && preferencesCookie !== null) {
      preferencesCheckbox.checked = preferencesCookie === 'true';
    }

    if ((isCaliforniaVisitor || isEUVisitor) && !hasSetPreferences) {
      // Auto-display the consent popup for California and EU visitors
      if (consentPopup && overlay) {
        consentPopup.style.display = 'block';
        consentPopup.setAttribute('aria-hidden', 'false');
        overlay.style.display = 'block';
         if (window.matchMedia("(max-width: 767px)").matches) {
            handleBodyAriaHidden(true, consentPopup);
          }
        
        
        setTimeout(() => {
          if (closePopupButton) {
            closePopupButton.focus();
          }
        }, 50);
      }
    }
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          console.log('we can no use consent settings from shopify');
        } else {
          if(!isCaliforniaVisitor && !isEUVisitor){
            let marketingAllowed = window.Shopify.customerPrivacy.marketingAllowed() == true ? true : 'x';
            let analyticsProcessingAllowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed() == true ? true : 'x';
            let preferencesProcessingAllowed = window.Shopify.customerPrivacy.preferencesProcessingAllowed() == true ? true : 'x';
    
            document.getElementById("marketingAllowed").checked = marketingAllowed == true ? true : false;
            document.getElementById("analyticsAllowed").checked = analyticsProcessingAllowed == true ? true : false;
            document.getElementById("preferencesAllowed").checked = preferencesProcessingAllowed == true ? true : false;

            setCookie('marketingAllowed', marketingAllowed, '/',180);
            setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, '/',180);
            setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, '/',180);
            gtagConcentMode('consent', 'update', {
              'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
              'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
              'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
              'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
            });
            dataLayer.push({event:'concent_updating'});
            if(localStorage.getItem("privacy-concent") === null || localStorage.getItem("privacy-concent") === "false"){
              consentFooter.style.display = 'flex';
              if (window.matchMedia("(max-width: 767px)").matches) {
                handleBodyAriaHidden(true, consentFooter);
              }
            }
          }
        }
      },
    );
  
    if (openConsentButton && consentPopup) {
  
      openConsentButton.addEventListener('click', function() {
        consentPopup.style.display = 'block';
        overlay.style.display = 'block';
        
        // Reset hiding to ensure we focus on popup now (moving from footer typically)
        if (window.matchMedia("(max-width: 767px)").matches) {
          handleBodyAriaHidden(false); 
          handleBodyAriaHidden(true, consentPopup);
        }
        
        
        // Set focus on the close button when modal opens and setup focus trap
        setTimeout(() => {
          if (closePopupButton) {
            closePopupButton.focus();
          }
          
          // Setup focus trap
          if (consentModalFocusTrapHandler) {
            consentModalFocusTrapHandler(); // Clean up previous trap if exists
          }
          consentModalFocusTrapHandler = setupConsentFocusTrap();
        }, 100);
      });
  
      cookieSettingsAnchors.forEach(function(el){
        el.addEventListener('click', function(e) {
          e.preventDefault();
          consentPopup.style.display = 'block';
          consentPopup.setAttribute('aria-hidden', 'false');
          overlay.style.display = 'block';
          if (window.matchMedia("(max-width: 767px)").matches) {
            handleBodyAriaHidden(false); 
            handleBodyAriaHidden(true, consentPopup);
          }
        });
      });

      consentFooter.addEventListener('keydown', function(e){
        if (e.key === "Escape" || e.key === "Esc") {
          consentFooter.style.display = 'none';
          localStorage.setItem("privacy-concent", "true");
          if (consentModalFocusTrapHandler) {
           if (window.matchMedia("(max-width: 767px)").matches) { 
            handleBodyAriaHidden(false); 
           }
          }
          document.body.setAttribute('tabindex', '-1');
          document.body.focus();
        }
      });

      consentPopup.addEventListener('keydown', function(e){
        if (e.key === "Escape" || e.key === "Esc") {
          consentPopup.style.display = 'none';
          consentPopup.setAttribute('aria-hidden', 'true');
          overlay.style.display = 'none';
          if (window.matchMedia("(max-width: 767px)").matches) {
            handleBodyAriaHidden(false); // Cleanup popup state
          }          
          // If footer is still visible, re-enable its isolation
          if (consentFooter && consentFooter.style.display !== 'none') {
            if (window.matchMedia("(max-width: 767px)").matches) {
             handleBodyAriaHidden(true, consentFooter);
            }
          }

          setTimeout(() => {
            if (openConsentButton) {
              openConsentButton.focus();
            }
          }, 50);
        }
      });

       toggleMkarketing.forEach(function(toggle) {
        toggle.addEventListener('click', function(e) {
        const marketingInput = this.parentElement.querySelector('input[type="checkbox"]');  
        if (marketingInput) {
          marketingInput.checked = !marketingInput.checked;
        }
      });
      });
    }
  
    if (saveConsentButton) {
      closeFooterButton.addEventListener('click', function(){
        consentFooter.style.display = 'none';
        localStorage.setItem("privacy-concent", "true");
        if (window.matchMedia("(max-width: 767px)").matches) {
          handleBodyAriaHidden(false); 
        }
        document.body.setAttribute('tabindex', '-1');
        //document.body.focus();
        announcementBarLink.focus();
      });
      closeFooterButton.addEventListener('keydown', function(e){
        if (e.key === "Tab" && e.shiftKey) {
          e.preventDefault();
          btnAcceptAll.focus();
        } else if (e.key === "Tab" && !e.shiftKey) {
          e.preventDefault();
          const collapseElement = document.querySelector('#custom-consent-footer p.collapse');
          if (collapseElement && collapseElement.classList.contains('show')) {
            // If collapse is expanded, focus on privacy link
            if (privacyLink) {
              privacyLink.focus();
            } else {
              showMoreButton.focus();
            }
          } else {
            // If collapse is not expanded, focus on show more button
            showMoreButton.focus();
          }
        }

      });
      btnAcceptAll.addEventListener('keydown', function(e){
        if (e.key === "Tab" && !e.shiftKey) {
          e.preventDefault();
          closeFooterButton.focus();
        }

      });
      privacyLink.addEventListener('keydown', function(e){
        if (e.key === "Tab" && e.shiftKey) {
          e.preventDefault();
          closeFooterButton.focus();
        }

      });
      closePopupButton.addEventListener('click', function(){
        // For California and EU users, closing the popup acts as "Decline All"
        if (isCaliforniaVisitor || isEUVisitor) {
          document.getElementById('marketingAllowed').checked = false;
          document.getElementById('analyticsAllowed').checked = false;
          document.getElementById('preferencesAllowed').checked = false;
          savePreferences();
        } else {
          // For non-California users, just close the popup
          consentPopup.style.display = 'none';
          if (window.matchMedia("(max-width: 767px)").matches) {
            consentPopup.setAttribute('aria-hidden', 'true');
          }
        overlay.style.display = 'none';
        if (window.matchMedia("(max-width: 767px)").matches) {
          handleBodyAriaHidden(false); 
        }
        // If footer is still visible, re-enable its isolation
        if (consentFooter && consentFooter.style.display !== 'none') {
           if (window.matchMedia("(max-width: 767px)").matches) {
            handleBodyAriaHidden(true, consentFooter);
           }
        }
        
        if (consentModalFocusTrapHandler) {
          consentModalFocusTrapHandler();
          consentModalFocusTrapHandler = null;
        }
          overlay.style.display = 'none';

          setTimeout(() => {
            if (openConsentButton) {
              openConsentButton.focus();
            }
          }, 50);
        }
      });
      saveConsentButton.addEventListener('click', function() {
        savePreferences();
        announcementBarLink.focus();
      });
      saveAcceptConsentAll.forEach(function(el){
        el.addEventListener('click', function() {
          document.getElementById('marketingAllowed').checked = true;
          document.getElementById('analyticsAllowed').checked = true;
          document.getElementById('preferencesAllowed').checked = true;
          savePreferences();
          announcementBarLink.focus();
        });
      });
      declineConsentAll.forEach(function(el){
        el.addEventListener('click', function() {
          document.getElementById('marketingAllowed').checked = false;
          document.getElementById('analyticsAllowed').checked = false;
          document.getElementById('preferencesAllowed').checked = false;
          savePreferences();
          announcementBarLink.focus();
        });
      });
      showMoreButton.addEventListener('click', function() {
        const showMoreContent = document.querySelector('#custom-consent-footer p');
        const hiddenTexts = showMoreContent.querySelectorAll('span:not(.first-part)');
        // const hiddenLink = showMoreContent.querySelector('a');
        showMoreContent.classList.toggle('show');

        hiddenTexts.forEach(function(hiddenText) {
          hiddenText.style.display = showMoreContent.classList.contains('show') ? 'inline' : 'none';
        });

        // if (hiddenLink) hiddenLink.style.display = showMoreContent.classList.contains('show') ? 'inline' : 'none';

        if (showMoreContent.classList.contains('show')) {
          setTimeout(() => {
            showMoreContent.focus();
          }, 100);
        } 
      });
    }
  }
  function savePreferences () {
    const consentPopup = document.getElementById('custom-consent-popup');
    const overlay = document.getElementById('custom-consent-overlay');
    const consentFooter = document.getElementById('custom-consent-footer');
  
    const marketingAllowed =  document.getElementById('marketingAllowed').checked  == true ? true :  'x';
    const analyticsProcessingAllowed =  document.getElementById('analyticsAllowed').checked  == true ? true :  'x';
    const preferencesProcessingAllowed =  document.getElementById('preferencesAllowed').checked  == true ? true :  'x';
  
    setCookie('marketingAllowed', marketingAllowed, '/',180);
    setCookie('analyticsProcessingAllowed', analyticsProcessingAllowed, '/',180);
    setCookie('preferencesProcessingAllowed', preferencesProcessingAllowed, '/',180);
    gtagConcentMode('consent', 'update', {  
      'ad_storage': marketingAllowed == true ? 'granted' : 'denied',
      'ad_user_data': marketingAllowed == true ? 'granted' : 'denied',
      'ad_personalization': marketingAllowed == true ? 'granted' : 'denied',
      'analytics_storage': analyticsProcessingAllowed == true ? 'granted' : 'denied'
    });
    dataLayer.push({event:'concent_updating'});
    const consentOptions = {
      marketing: marketingAllowed == true ? true : false,
      analytics: analyticsProcessingAllowed == true ? true : false,
      preferences: preferencesProcessingAllowed == true ? true : false
    };
    window.Shopify.customerPrivacy.setTrackingConsent(
      consentOptions,
      () => {
        consentPopup.style.display = 'none';
        consentPopup.setAttribute('aria-hidden', 'true');
        overlay.style.display = 'none';
        consentFooter.style.display = 'none';
        localStorage.setItem("privacy-concent", "true");
        if (window.matchMedia("(max-width: 767px)").matches) {
          handleBodyAriaHidden(false); 
        }
        
        if (consentModalFocusTrapHandler) {
          consentModalFocusTrapHandler();
          consentModalFocusTrapHandler = null;
        }
      }
    );
  }